import Vue from 'vue'
import Router from 'vue-router'

const Dashboard = resolve => require.ensure([], () => resolve(require('components/Dashboard')), 'Dashboard')
const DashboardIndex = resolve => require.ensure([], () => resolve(require('modules/dashboard/Index')), 'DashboardIndex')
const NotFound = resolve => require.ensure([], () => resolve(require('modules/dashboard/404')), 'NotFound')

// Form
const BlankPage = resolve => require.ensure([], () => resolve(require('modules/common-page/BlankPage')), 'BlankPage')
const NotFoundSecond = resolve => require.ensure([], () => resolve(require('modules/dashboard/500')), 'NotFoundSecond')

// topics
const TopicsList = resolve => require.ensure([], () => resolve(require('modules/topics/TopicsList')), 'TopicsList')
const TopicsListTplEdit = resolve => require.ensure([], () => {
  // require('modules/template/templateItem')
  return resolve(require('modules/topics/TopicsList/edittpl'))
}, 'TopicsListTplEdit')
// Courseware
const FeaturePage = resolve => require.ensure([], () => resolve(require('modules/courseware-feature/FeaturePage')), 'FeaturePage')
const CoursewareList = resolve => require.ensure([], () => resolve(require('modules/courseware/CoursewareList')), 'CoursewareList')
const CoursewareItem = resolve => require.ensure([], () => resolve(require('modules/courseware/CoursewareItem')), 'CoursewareItem')
const TransformFutureCourseList = resolve => require.ensure([], () => resolve(require('modules/transformFutureCourseList')), 'TransformFutureCourseList')
const pageList = resolve => require.ensure([], () => resolve(require('modules/pageList')), 'pageList')
const h5upload = resolve => require.ensure([], () => resolve(require('modules/h5upload')), 'h5upload')

// preview
const Preview = resolve => require.ensure([], () => resolve(require('modules/preview')), 'Preview')

// template
const Template = resolve => require.ensure([], () => resolve(require('modules/template/templateList')), 'Template')
const Category = resolve => require.ensure([], () => resolve(require('modules/template/category')), 'Category')
const TemplateItem = resolve => require.ensure([], () => resolve(require('modules/template/templateItem')), 'TemplateItem')

// background
const BackgroundList = resolve => require.ensure([], () => resolve(require('modules/background/BackgroundList')), 'BackgroundList')

// logo
const LogoList = resolve => require.ensure([], () => resolve(require('modules/logo-manage/logo-list')), 'LogoList')

// 未来课件
const VersionManage = resolve => require.ensure([], () => resolve(require('modules/future/VersionList')), 'VersionManage')
const SdkVersionManage = resolve => require.ensure([], () => resolve(require('modules/future/SdkVersionList')), 'SdkVersionManage')
const TemplateManage = resolve => require.ensure([], () => resolve(require('modules/future/TemplateManage')), 'TemplateManage')
const FutureItem = resolve => require.ensure([], () => resolve(require('modules/future/FutureItem')), 'FutureItem')

// 自动化质检
const qualityInspection = resolve => require.ensure([], () => resolve(require('modules/test/quality-inspection')), 'qualityInspection')
const qualityInspectionProgrress = resolve => require.ensure([], () => resolve(require('modules/test/quality-inspection/progress')), 'qualityInspectionProgrress')
const qualityInspectionReport = resolve => require.ensure([], () => resolve(require('modules/test/quality-inspection/report')), 'qualityInspectionReport')
const coursewareTestList = resolve => require.ensure([], () => resolve(require('modules/test/courseware-test-list')), 'coursewareTestList')

// 组课工具 组件
const coursewareTool = resolve => require.ensure([], () => resolve(require('modules/courseware-tool/templateList')), 'coursewareTool')
const coursewareToolPreview = resolve => require.ensure([], () => resolve(require('modules/courseware-tool/preview')), 'coursewareToolPreview')

// 模板管理 新整合模板列表
const coursewareList = resolve => require.ensure([], () => resolve(require('modules/courseware-list')), 'coursewareList')

// 模版管理 模版统计
const templateCount = resolve => require.ensure([], () => resolve(require('modules/template-count/templateCount')), 'templateCount')

// 模版管理 课件播放器
const templatePlayer = resolve => require.ensure([], () => resolve(require('modules/template-player/index')), 'templatePlayer')
// 角色管理
const roleManagement = resolve => require.ensure([], () => resolve(require('modules/role-management/index')), 'roleManagement')
// 上传新角色
const newRole = resolve => require.ensure([], () => resolve(require('modules/role-management/newRole')), 'newRole')
const coursewareTplEdit = resolve => require.ensure([], () => {
  require('modules/template/templateItem')
  return resolve(require('modules/courseware-list/edittpl'))
}, 'coursewareTplEdit')

//nb列表页面
const nbList = resolve => require.ensure([], () => resolve(require('modules/nbPage/index')), 'nbList')

// 团队管理
const teamManagement = resolve => require.ensure([], () => resolve(require('modules/teamManagement/index')), 'teamManagement')
// 切片库列表
const sliceLibraryList = resolve => require.ensure([], () => resolve(require('modules/sliceLibrary/List')), 'SliceLibraryList')

// 路由方法
import setRouter from './setRouter'

// Routes
const routes = [
  {
    path: '/preview/:id/packageid/:package_id',
    component: Preview,
    name: 'preview-package'
  },
  {
    path: '/preview/:id',
    component: Preview,
    name: 'preview'
  },
  {
    path: '/template/preview/:template_id',
    component: Preview,
    name: 'template-preview'
  },
  {
    path: '/courseware/item/:id',
    name: 'courseware-item',
    component: CoursewareItem
  },
  {
    path: '/coursewareToolPreview/:template_id',
    name: 'coursewareToolPreview',
    component: coursewareToolPreview
  },
  {
    path: '/',
    component: Dashboard,
    meta: { requiresAuth: true },
    beforeEnter: (to, from, next) => {
      document.body.className += 'skin-gradient sidebar-mini'
      next()
    },
    activate: function () {
      this.$nextTick(function () {
        // => 'DOM loaded and ready'
        alert('test')
      })
    },
    children: [
      {
        path: '',
        name: 'courseware-list-default',
        component: CoursewareList
      },
      {
        path: '/courseware/transformFutureCourseList',
        name: 'transform-future-course',
        component: TransformFutureCourseList
      },
      {
        path: '/courseware/pageList',
        name: 'transform-page-list',
        component: pageList
      },
      {
        path: '/courseware/h5upload',
        name: 'transform-h5-upload',
        component: h5upload
      },
      {
        path: '/topicsList',
        name: 'topicsList',
        component: TopicsList
      },
      {
        path: '/topicsListTplEdit',
        name: 'topicsListTplEdit',
        component: TopicsListTplEdit
      },
      {
        path: '/feature',
        name: 'feature-page',
        component: FeaturePage
      },
      {
        path: '/courseware/list',
        name: 'courseware-list',
        component: CoursewareList
      },
      {
        path: '/template/list',
        name: 'template-list',
        component: Template
      },
      {
        path: '/template/category',
        name: 'template-category',
        component: Category
      },
      {
        path: '/template/create',
        name: 'template-create',
        component: TemplateItem
      },
      {
        path: '/template/edit/:id',
        name: 'template-edit',
        component: TemplateItem
      },
      {
        path: '/coursewareList',
        name: 'coursewareList',
        component: coursewareList
      },
      {
        path: '/templateCount',
        name: 'templateCount',
        component: templateCount
      },
      {
        path: '/templatePlayer',
        name: 'templatePlayer',
        component: templatePlayer
      },
      {
        path: '/roleManagement',
        name: 'roleManagement',
        component: roleManagement
      },
      {
        path: '/newRole',
        name: 'newRole',
        component: newRole
      },
      {
        path: '/coursewareTplEdit',
        name: 'coursewareTplEdit',
        component: coursewareTplEdit
      },
      {
        path: '/background/list',
        name: 'background-list',
        component: BackgroundList
      },
      {
        path: '/logo/list',
        name: 'logo-list',
        component: LogoList
      },
      {
        path: '/version/manage',
        name: 'version-manage',
        component: VersionManage
      },
      {
        path: '/sdk_version/manage',
        name: 'sdk-version-manage',
        component: SdkVersionManage
      },
      {
        path: '/future/template',
        name: 'future-template',
        component: TemplateManage
      },
      {
        path: '/future/create',
        name: 'future-create',
        component: FutureItem
      },
      {
        path: '/future/edit/:id',
        name: 'future-edit',
        component: FutureItem
      },
      {
        path: '/test/inspection',
        name: 'test-inspection',
        component: qualityInspection
      },
      {
        path: '/test/progress',
        name: 'test-inspection-progress',
        component: qualityInspectionProgrress
      },
      {
        path: '/test/report',
        name: 'test-inspection-report',
        component: qualityInspectionReport
      },
      {
        path: '/test/coursewareTestList',
        name: 'test-coursewareTestList',
        component: coursewareTestList
      },
      {
        path: 'coursewareTool',
        name: 'coursewareTool',
        component: coursewareTool
      },
      {
        path: '/dashboard',
        name: 'dashboard-first',
        component: DashboardIndex
      },
      {
        path: '/blank-page',
        name: 'blank-page',
        component: BlankPage
      },
      {
        path: '/nbList',
        name: 'nbList',
        component: nbList
      },
      {
        path: '/teamManagement',
        name: 'teamManagement',
        component: teamManagement,
      },
      {
        path: '/sliceLibrary',
        component: sliceLibraryList,
        name: 'sliceLibrary'
      },
      {
        path: '/404',
        name: '404-eror',
        component: NotFound
      },
      {
        path: '/500',
        name: '500',
        component: NotFoundSecond
      },
      {
        path: '*',
        name: '404',
        component: NotFound
      }
    ]
  }
]
Vue.use(Router)
const resultRouter = new Router({
  routes,
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: function (to, from, savedPosition) {
    return (
      savedPosition || {
        x: 0,
        y: 0
      }
    )
  }
})
resultRouter.beforeEach(setRouter.beforeEach)
export default resultRouter



// WEBPACK FOOTER //
// ./src/config/routes.js